import React from "react";
import { TPrimitiveId } from "../Select/Select";
import { TTableRow } from "./TableConst";
import GUI from "../GUI";

export type TTDProps = React.ComponentPropsWithoutRef<"td">
export type TTableCellValue<T extends TTableRow> = (row:T, col:string) => TPrimitiveId&Date
export type TTableCellText<T extends TTableRow> = (row:T, col:string) => string|JSX.Element|JSX.Element[]
export type TTDPropper<T extends TTableRow> = TTDProps|( (row:T, col:string) => TTDProps )
export type TTableCellProps<T extends TTableRow> = {
    row:T
    col:string
    td?:TTDPropper<T>
    cellValue?:TTableCellValue<T>
    cellText?:TTableCellText<T>
}

function str(val:any){
    if (val===undefined || val==null) return ""
    else return String(val)
}

export default function TableCell<T extends TTableRow>(props:TTableCellProps<T>) {
    const value = props.cellText ? props.cellText(props.row, props.col) : str(props.row[props.col])
    const tdProps = GUI.getProps(props.td, props.row, props.col) 
    return <td {...tdProps}>{value}</td>
}